export const REJECTED = 'rejected';
export const MANAGE_TICKETS = 'manageTickets';
export const CROSS = 'cross';
export const TICK = 'tick';
export const CLOSE = 'close';
export const CONFIRM_CANCEL_ONE = 'confirmCancelOne';
export const CONFIRM_CANCEL_MULTIPLE = 'confirmCancelMultiple';
export const BACK_TO_TICKET = 'backToTicket';
export const CANCEL_ONE_TICKET = 'cancelOne';
export const CANCEL_UP_TO_ALL_TICKETS = 'cancelUpToAllTickets';
export const CLEAR = 'clear';
export const CANCELLED = 'cancelled';
export const SOLD_OUT = 'soldOut';
export const ENTER_EARLY_ACCESS_CODE = 'enterEarlyAccessCode';
export const SUBMIT_CODE = 'submitCode';
export const ACCESS_CODE_MISSING = 'accessCodeMissing';
export const ADD_TO_WATCHLIST = 'addToWatchlist';